/* @flow */

export const virtualBraindateFeature = 'video-call';
export const virtualBraindateConnectSrc =
  'https://ecs.us1.twilio.com wss://global.vss.twilio.com wss://sdkgw.us1.twilio.com';

export const virtualBraindateBeforeDuration = 5 * 60; // in seconds
export const virtualBraindateExtendedDuration = 10 * 60; // in seconds
export const takeOverMinutesToBraindate = 3;
